(() => {
  if (customElements.get('lv-cart-rewards')) return;
  let pendingCart;
  function currentCart() {
    if (!pendingCart) {
      pendingCart = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}})
        .then(response => {if (!response.ok) throw new Error('Cart unavailable'); return response.json();})
        .finally(() => {pendingCart = null;});
    }
    return pendingCart;
  }
  class CartRewards extends HTMLElement {
    connectedCallback() {
      this.strings = JSON.parse(this.querySelector('[data-rewards-strings]').textContent);
      this.render({original_total_price: Number(this.dataset.original), total_price: Number(this.dataset.total), currency: this.dataset.currency});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          const cart = event.cartData;
          return (cart && Number.isFinite(cart.total_price) && Number.isFinite(cart.original_total_price)
            ? Promise.resolve(cart) : currentCart())
            .then(data => this.render(data)).catch(() => {this.hidden = true;});
        });
      }
      this.onReturn = () => currentCart().then(data => this.render(data)).catch(() => {});
      window.addEventListener('pageshow', this.onReturn);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.onReturn);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(cents / 100);
    }
    render(cart) {
      this.hidden = cart.currency !== 'USD';
      if (this.hidden) return;
      const original = Math.max(0, cart.original_total_price);
      const total = Math.max(0, cart.total_price);
      const message = original < 5000 ? this.strings.next10.replace('[amount]', this.money(5000 - original))
        : original < 7500 ? this.strings.next15.replace('[amount]', this.money(7500 - original))
        : this.strings.unlocked15;
      this.querySelector('[data-discount-message]').textContent = message;
      const discountTarget = original < 5000 ? 5000 : 7500;
      this.querySelector('[data-discount-progress]').max = discountTarget;
      this.querySelector('[data-discount-progress]').value = Math.min(discountTarget, original);
      const rate = original > 0 ? Math.min(0.85, total / original) : 0.85;
      const remaining = total >= 8500 ? 0 : Math.max(1, Math.ceil(8500 / (rate || 0.85) - original));
      this.querySelector('[data-shipping-message]').textContent = total >= 8500
        ? this.strings.shippingUnlocked
        : this.strings.shippingNext.replace('[amount]', this.money(remaining));
      this.querySelector('[data-shipping-progress]').value = Math.min(8500, total);
    }
  }
  customElements.define('lv-cart-rewards', CartRewards);
})();